module.exports = __webpack_public_path__ + "img/volume-open.51e490fd.svg";